export const educationData = [
    {
        id: 1,
        institution: 'University at Buffalo, New York',
        course: 'MS in Data Science',
        startYear: '2021',
        endYear: '2023',
        score : '3.96 / 4.00 GPA'
    },
    {
        id: 2,
        institution: 'Vishweshwaraiah Technological University, India',
        course: 'BE in Electrical and Electronic Engineering',
        startYear: '2010',
        endYear: '2014',
        score: '73.78%'
    }
]